import React from "react";
import {Form, Input, Spin, Button} from "antd";
import {Trans} from "@lingui/macro";
import useSafeState from "../../utils/safe-state";
import {useAxios} from "../../utils/hooks";
import {openNotification} from "../../utils/openNotification";

interface Props {
    data?: any;
    mode?: 'Add new' | 'Edit';
    onSuccess?: () => void;
    onClose?: () => void;
}

const SupplierForm = ({data, mode = 'Add new', onSuccess, onClose}: Props) => {
    const [form] = Form.useForm();
    const axiosInstance = useAxios(process.env.REACT_APP_API_BASE_URL + "");
    const [loading, setLoading] = useSafeState(false);

    React.useEffect(() => {
        form.resetFields();
        if (data) {
            form.setFieldsValue({
                id: data.id,
                name: data.name,
                remark: data.remark
            });
        }
    }, [data]);

    const handleSubmit = () => {
        if (axiosInstance.current == null) {
            return;
        }
        setLoading(true);
        const payload: any = {
            name: form.getFieldValue('name'),
            remark: form.getFieldValue('remark')
        };

        if (mode === 'Edit') {
            payload.id = form.getFieldValue('id');
        }

        const request = mode === 'Edit' && payload.id
            ? axiosInstance.current.put(`/resource/suppliers/${encodeURIComponent(payload.id)}`, payload)
            : axiosInstance.current.post('/resource/suppliers', payload);

        request
            .then(() => {
                openNotification('success', <Trans>Saved</Trans> as any);
                onSuccess && onSuccess();
                onClose && onClose();
            })
            .catch((error: any) => {
                const message = error && error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : 'Save failed';
                openNotification('error', message);
            })
            .finally(() => setLoading(false));
    };

    return (
        <Spin spinning={loading}>
            <Form layout="vertical" form={form} onFinish={handleSubmit}>
                <Form.Item
                    label={<Trans>Name</Trans>}
                    name="name"
                    rules={[{required: true, message: <Trans>Please enter the supplier name</Trans>}]}>
                    <Input />
                </Form.Item>
                <Form.Item label={<Trans>Remark</Trans>} name="remark">
                    <Input.TextArea rows={3} />
                </Form.Item>
                <Button type="primary" onClick={() => form.submit()}>
                    <Trans>Save</Trans>
                </Button>
            </Form>
        </Spin>
    );
};

export default SupplierForm;
